import React, { useState, useRef, useEffect } from "react";
import { logo, eyeSeen, eyeUnseen, eyeSeenFocus, eyeUnseenFocus } from "../../Image/Index";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ValidatorForm } from "react-form-validator-core";
import { Internal_Token, Signin, Token_Generator, adminsignin } from "../../actions/auth";
import TextValidator from "../partial/TextValidator";
import { decrypt, encrypt } from "../../utils/encodingdecoding";

function AdminSignIn({ signing, authReducer }) {
    const location = useLocation();
    const formRef = useRef();
    // const [incorrectPasswordAttempts, setIncorrectPasswordAttempts] = useState(JSON.parse(sessionStorage.getItem("incorrectPasswordAttempts")) || 0);
    const navigate = useNavigate();
    const [isRevealPwd, setIsRevealPwd] = useState(false);
    const [pswdFocus, setPswdFocus] = useState(false);
    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });
    const [error, setError] = useState("");
    const [loader, setLoader] = useState(false);
    const [merchantIds, setMerchantIds] = useState();
    const [logo, setLogo] = useState("");
    const [uploadSource, setUploadSource] = useState("");
    const [response, setResponse] = useState([]);


    const { email, password } = formData;



    const onChange = (e) => {
        setFormData({ ...formData, ...{ [e.target.name]: e.target.value } });
    };

 


 
    const onSubmit = async () => {

        setLoader(true);
      
       
        const res = await Signin(formData);
      
        if (res?.message=== "Sucess") {
           localStorage.setItem("lastName",res?.data[0]?.lastName)
           localStorage.setItem("email",res?.data[0]?.email)
           localStorage.setItem("mobileNumber",res?.data[0]?.mobileNumber)
            localStorage.setItem("name", res?.data[0]?.firstName);
            localStorage.setItem("creditBalance", res?.data[0]?.creditBalance);
            localStorage.setItem("userId", res?.data[0]?.userId);

            localStorage.setItem("moduleAccess","U2FsdGVkX1%2BVkI4yhZDfHOogQC%2FXdtiIPCWcmyrsf4SRePkpbt0ERXKb%2FLm6QhUzFwW44A34VkGwULrCbdUz4sXTfvjtw%2Bh3COS92Pe%2FU7GxroMAwzEgu2ydBWaq5rUu" );
          
            navigate("/dashboard");
        } else {
            setError(res?.message);
            setLoader(false)
        }
        setLoader(false);
    };

    return (
        <section className="section signUpPage">
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <div className="signUpPage__main" style={{background:"none"}}>
                <div className="signUpPage__Boxed">
                    <div className="signUpPage__heading">
                        {/* <figure>
                            <img src={logo} alt="logo" />
                        </figure> */}
                        <h1>Sign In</h1>
                      
                    </div>
                    <div className="signUpPage__form">
                        <ValidatorForm className="signUpPage__formSection" ref={formRef} onSubmit={(e) => onSubmit(e)}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        {/* <label className="form-label">Email ID</label> */}
                                        <TextValidator className="form-control" placeholder="Enter Email ID" name="email" maxLength="50" value={email} type="email" onChange={onChange} validators={["required"]} errorMessages={["Email address is required."]} />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group withIcon">
                                        {/* <label className="form-label">Password</label> */}
                                        <TextValidator placeholder="Enter Password" className="form-control" name="password" value={password} type={isRevealPwd ? "text" : "password"} onChange={onChange} validators={["required"]} errorMessages={["Password is required."]} />
                                        <span className="passwordToggle">{pswdFocus ? <img className="onFocus" title={isRevealPwd ? "Hide password" : "Show password"} src={isRevealPwd ? "/Images/eyeUnseenFocus.png" : "/Images/eyeSeenFocus.png"} alt="eye" onClick={() => setIsRevealPwd((prevState) => !prevState)} /> : <img className="onBlur" title={isRevealPwd ? "Hide password" : "Show password"} src={isRevealPwd ? "/Images/eyeUnseen.png" : "/Images/eyeSeen.png"} alt="eye" onClick={() => setIsRevealPwd((prevState) => !prevState)} />}</span>
                                        {error && <span className="textValidatorError">{error}</span>}
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    {/* <div className="form-group">{showReCAPTCHA && <ReCAPTCHA style={{ display: "inline-block" }} theme="dark" ref={recaptchaRef} sitekey={process.env.REACT_APP_GOOGLE_KEY} onChange={handleChange} />}</div>
                                    {error && <div style={{ color: "red" }}>{error}</div>} */}
                                </div>
                                 <div className="col-md-12">
                                    <div className="form-group">
                                        <p className="text-end">
                                            <Link to="/forgot-password">Forgot Password ?</Link>
                                        </p>
                                    </div>
                                </div> 
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <button type="submit" className="btn btn-primary btn-lg w-100">
                                            Sign in
                                        </button>
                                    </div>
                                </div>
                                 <div className="col-md-6">
                                    <div className="form-group">
                                        <p>
                                            Don't have an account? <Link to="/signup">Sign Up</Link>
                                        </p>
                                    </div>
                                </div> 
                                {/* <div className="col-md-6">
                                    <div className="form-group">
                                        <p className="text-end">
                                            <Link to="/contactus">Contact Us</Link>
                                        </p>
                                    </div>
                                </div> */}
                            </div>
                        </ValidatorForm>
                    </div>
                </div>
            </div>
        </section>
    );
}



// export default SignIn;
export default AdminSignIn
